import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { useState } from "react";

const ExportDetailJurnalForBukuBesarToExcel = ({ excelData, fileName }) => {
  const [isRenderData, setIsRenderData] = useState(false);

  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToExcel = async () => {
    setIsRenderData(true);
    const rows = [];

    const dataBukuBesar = excelData;
    for (const excel of dataBukuBesar) {
      let row = {};

      row["Nomor Transaksi"] = excel?.nomor_transaksi;
      row["Tanggal Transaksi"] = excel?.tanggal_transaksi;
      row["Debet"] = parseInt(excel?.debet);
      row["Kredit"] = parseInt(excel?.kredit);
      row["Nama Anggaran"] = excel?.nama_anggaran;
      row["Keterangan Anggaran"] = excel?.keterangan_anggaran;
      row["Kode Akun"] = excel?.kode_akun;
      row["Nama Akun"] = excel?.nama_akun;

      rows.push(row);
    }

    setIsRenderData(false);
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <button
      onClick={(e) => exportToExcel(e)}
      className="bg-emerald-500 px-3 py-1 text-white rounded shadow-lg active:bg-lightBlue-500"
      disabled={isRenderData}
    >
      <p>Export to Excel</p>
    </button>
  );
};

export default ExportDetailJurnalForBukuBesarToExcel;
